import React from "react";
import { motion } from "framer-motion";
import { Dices, Gamepad2, Flag } from "lucide-react";
import { useMedia, resolveUrl } from "../../context/MediaContext";
import { KineticText, Reveal } from "../../lib/motion";

export default function PlayAfternoon() {
  const { slots } = useMedia();
  return (
    <section className="relative min-h-[100svh] flex items-center py-24 px-6">
      <div className="max-w-[1300px] mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-body text-xs tracking-[0.35em] uppercase text-[#201A17]/60">Afternoon &middot; 4:00 PM</span>
            </Reveal>
            <h2 className="font-display font-extrabold text-[#201A17] leading-[0.88] text-6xl md:text-8xl mt-4">
              <KineticText text="Let the" />
              <span className="font-serif-i italic font-normal gradient-text"> games begin</span>
            </h2>
            <Reveal delay={0.1}>
              <p className="mt-7 text-[#201A17]/70 text-lg font-light leading-relaxed max-w-md">
                A full-size poker table for the grown-ups and a retro arcade machine for the
                kids. The afternoon at The Jackson House is anything but quiet.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="flex flex-col gap-3 mt-8">
                {[{ i: Dices, t: "Full-size poker table" }, { i: Gamepad2, t: "Retro arcade machine" }, { i: Flag, t: "Backyard mini golf" }].map((c) => (
                  <div key={c.t} className="flex items-center gap-3">
                    <span className="w-11 h-11 rounded-full sunset-fill grid place-items-center text-white shrink-0"><c.i size={18} /></span>
                    <span className="font-body font-medium text-[#201A17]">{c.t}</span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          {/* playful bento */}
          <div className="lg:col-span-7 grid grid-cols-2 gap-4">
            <motion.div whileHover={{ y: -8 }} className="col-span-2 rounded-[28px] overflow-hidden h-64 shadow-xl">
              <img src={resolveUrl(slots.cardIndoor)} alt="Poker table" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div whileHover={{ y: -8 }} className="rounded-[28px] overflow-hidden h-56 shadow-xl">
              <img src={resolveUrl(slots.cardRGV)} alt="Backyard" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div whileHover={{ y: -8 }} className="rounded-[28px] overflow-hidden h-56 shadow-xl">
              <img src={resolveUrl(slots.piano)} alt="Fun" className="w-full h-full object-cover" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
